export default __webpack_public_path__ + "static/media/dhl-express.081bc839.svg";